import { GC_BLANK_DEFAULT } from "../../globalConstants";
export default {
  default: GC_BLANK_DEFAULT,
  style: 2,
  listType: 'type-my-own',
  typeMyOwn: ''
};